const statusStyles = {
  "not-started": "bg-gray-500/15 text-gray-400",
  "in-progress": "bg-blue-500/15 text-blue-400",
  completed: "bg-emerald-500/15 text-emerald-400",
  blocked: "bg-red-500/15 text-red-400",
};

const statusLabels = {
  "not-started": "Not Started",
  "in-progress": "In Progress",
  completed: "Completed",
  blocked: "Blocked",
};

export default function StatusBadge({ status }) {
  return (
    <span
      className={`inline-block px-1.5 py-0.5 rounded text-[10px] font-medium ${
        statusStyles[status] || statusStyles["not-started"]
      }`}
    >
      {statusLabels[status] || status}
    </span>
  );
}
